export const INTRO_OFFER_REMINDER_EVENT = "local-voice:intro-offer-reminder";

export function queueIntroOfferReminder() {
  window.dispatchEvent(new Event(INTRO_OFFER_REMINDER_EVENT));
}
